function generateUniqueId() {
  const timestamp = Date.now().toString(36);
  const randomValue = Math.random().toString(36).substring(2, 15);
  return timestamp + randomValue;
}
function beaconToken(tokenName) {
  const value = getComputedStyle(document.documentElement).getPropertyValue(tokenName).trim();
  return {
    toString: () => value,
    valueOf: () => value,
    unitless: parseFloat(value) || 0
  };
}
function isValidDate(date) {
  if (!date) return false;
  if (date instanceof Date) {
    return !Number.isNaN(date.getTime());
  }
  if (typeof date === "string") {
    const regex = /^\d{4}-\d{1,2}-\d{1,2}$/;
    if (!regex.test(date)) return false;
    const [year, month, day] = date.split("-").map(Number);
    if (month < 1 || month > 12 || day < 1 || day > 31) return false;
    const parsedDate = Date.parse(
      `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`
    );
    if (Number.isNaN(parsedDate)) return false;
    const dateObject = new Date(parsedDate);
    return dateObject.getUTCFullYear() === year && dateObject.getUTCMonth() + 1 === month && dateObject.getUTCDate() === day;
  }
  return false;
}
function formatDateToISOString(date) {
  if (isValidDate(date)) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  return void 0;
}
function parseDate(dateStr) {
  if (isValidDate(dateStr)) {
    if (dateStr instanceof Date) return dateStr;
    const [year, month, day] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day);
  }
  return void 0;
}
function isDateInRange(date, min, max) {
  const actualDate = date instanceof Date ? date : parseDate(date);
  const minDate = min instanceof Date ? min : parseDate(min);
  const maxDate = max instanceof Date ? max : parseDate(max);
  if (!actualDate) {
    return false;
  }
  if (minDate === void 0 && maxDate === void 0) {
    return true;
  }
  if (!min && !minDate) {
    return actualDate <= maxDate;
  }
  if (!max && !maxDate) {
    return actualDate >= minDate;
  }
  return actualDate >= minDate && actualDate <= maxDate;
}
function getLocaleDateFormat(locale) {
  const mockDate = new Date(2024, 8, 27);
  const dateParts = new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(mockDate);
  return dateParts.map((part) => part.type).filter((type) => ["day", "month", "year"].includes(type));
}
function convertLocaleStringToISOString(dateString, locale) {
  const dateValues = dateString == null ? void 0 : dateString.match(/\d+/g);
  if ((dateValues == null ? void 0 : dateValues.length) !== 3) {
    return void 0;
  }
  const dateObj = {};
  const formatOrder = getLocaleDateFormat(locale);
  formatOrder.forEach((part, index) => {
    dateObj[part] = dateValues[index];
  });
  const date = `${dateObj.year}-${dateObj.month.padStart(2, "0")}-${dateObj.day.padStart(2, "0")}`;
  return isValidDate(date) ? date : void 0;
}
function convertISOStringToLocaleString(dateString, locale) {
  const date = parseDate(dateString);
  if (isValidDate(date)) {
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).format(date);
  }
  return void 0;
}
export {
  beaconToken,
  convertISOStringToLocaleString,
  convertLocaleStringToISOString,
  formatDateToISOString,
  generateUniqueId,
  getLocaleDateFormat,
  isDateInRange,
  isValidDate,
  parseDate
};
//# sourceMappingURL=utils.mjs.map
